export const MenuItems = [
  {
    title: 'Home',
    url: "/home#home",
    cName:'nav-link'
  },
  {
    title: 'About',
    url: "/home#about",
    cName:'nav-link'
  },
  // {
  //   title: 'Skills',
  //   url: "/#skills",
  //   cName:'nav-link'
  // },
  {
    title: 'My Projects',
    url: "/home/#my-projects",
    cName:'nav-link'
  },
  // {
  //   title: 'Certifications',
  //   url: "/home/#certifications",
  //   cName:'nav-link'
  // },
  {
    title: 'Contact',
    url: "/home/#contact",
    cName:'nav-link'
  },
]